const brandColors = {
  ezOrange: '#ff6b1e',
  ezLogoGreen: '#88bb40',
  ezGreen: '#609b3b',
  ezBlue: '#3e90d6',
} as const;

export const newBrandColors = {
  kaleGreen: '#1D3C34',
  cilantroGreen: '#034A34',
  ezGreen: '#00B373',
  vanillaFrosting: '#F9FAE4',
  blackOlive: '#151515',
  guavaRed: '#FF585D',
} as const;

export const blueberry = {
  50: '#f5faff',
  100: '#e4f1ff',
  200: '#bedcff',
  300: '#5d9cff',
  400: '#3a64df',
  500: '#1e4dc3',
  600: '#123aa0',
  700: '#07297c',
  800: '#021859',
} as const;

export const pomegranate = {
  50: '#fff1fa',
  100: '#ffdff0',
  200: '#ffc5e8',
  300: '#f2519d',
  400: '#ca0378',
  500: '#980060',
  600: '#820b58',
  700: '#620345',
  800: '#430031',
} as const;

export const papaya = {
  50: '#fff9ed',
  100: '#ffedd1',
  200: '#ffd187',
  300: '#fbb41a',
  400: '#b44f01',
  500: '#943c00',
  600: '#772c00',
  700: '#651900',
  800: '#410d00',
} as const;

export const peppercorn = {
  50: '#f9f9fb',
  100: '#f0f2f7',
  200: '#d6d9e1',
  300: '#989ca8',
  400: '#666974',
  500: '#565964',
  600: '#41434a',
  700: '#303135',
  800: '#1b1212',
} as const;

export const guava = {
  50: '#fff2f4',
  100: '#ffe8ea',
  200: '#ffc9ca',
  300: '#ff585d',
  400: '#d90026',
  500: '#b10213',
  600: '#8d0202',
  700: '#680900',
  800: '#460800',
} as const;

const colors = {
  white: '#ffffff',
  functionGray: '#fafafb',
  borderGray: '#d6d9e1',
  lightestGray: '#f4f7f8',
  textPrimary: '#1b1212',
  lighterBlueGray: '#e9eff5',
  lightGray: '#ced4d9',
  mediumGray: '#b2b3b3',
  darkBlueGray: '#8b99a6',
  darkGray: '#565a5c',
  navigationGradientLight: '#373d43',
  navigationGradientDark: '#1b2023',
  lightRed: '#fdefef',
  mediumRed: '#f7c1c1',
  red: '#ec5353',
  darkRed: '#ae4d4d',
  lightOrange: '#ffeee5',
  orange: brandColors.ezOrange,
  orangeDarker: '#f2661c',
  lemon100: '#FFFCC4',
  lemon300: '#FFF200',
  lightYellow: '#ffe352',
  yellow: '#e9a801',
  lightGreen: '#f3f8eb',
  mediumGreen: '#c7dfa7',
  kiwi100: '#e1fccc',
  kiwi400: '#2f7f00',
  kiwi600: '#174f00',
  green: brandColors.ezLogoGreen,
  green600: '#00592D',
  papaya25: '#FFFAF2',
  orange500: '#C75300',
  guava350: '#D12E2E',
  darkGreen: brandColors.ezGreen,
  teal: '#1bbc9b',
  lightBlue: '#f6fbff',
  perrywinkle: '#ebf7ff',
  perrywinkleMedium: '#c1def4',
  perrywinkleDark: '#b1d5f2',
  iceBlue: '#77b1e2',
  ezBlue: brandColors.ezBlue,
  linkBlue: brandColors.ezBlue,
  linkActive: '#1e70bf',
  purple: '#9b59b6',
  purple100: '#f8f3fa',
  purple400: '#803799',
  gold: '#926a00',
  blueberry,
  papaya,
  peppercorn,
  guava,
  green100: '#008054',
  yellow100: '#f9d055',
  red100: '#ff585d',
  blue100: '#3f61ff',
  grey120: '#f5f7f7',
} as const;

export const namedColors = {
  alertRed: colors.papaya[400],
  bannerYellow: colors.lightYellow,
  errorBackground: colors.lightRed,
  errorBorder: colors.mediumRed,
  errorStripe: colors.red,
  errorText: colors.red,
  successBackground: colors.lightGreen,
  successBorder: colors.mediumGreen,
  successStripe: colors.green,
  infoBackground: colors.perrywinkle,
  infoBorder: colors.perrywinkleDark,
  infoStripe: colors.linkBlue,
} as const;

export const panelColors = {
  primary: colors.ezBlue,
} as const;

export default colors;
